module.exports = __webpack_public_path__ + "static/media/login_banner.09af301f.svg";